
import { GoogleGenAI } from "@google/genai";

export async function generatePropertyDescription(params: {
  title: string,
  type: string,
  location: string,
  bedrooms?: number,
  features: string[]
}) {
  // Always initialize GoogleGenAI inside the function as recommended to ensure fresh API key usage.
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
  const prompt = `Write a professional, compelling, and luxurious real estate description for a ${params.type} called "${params.title}" located in ${params.location}. 
  Include these features: ${params.features.join(', ')}. 
  ${params.bedrooms ? `It has ${params.bedrooms} bedrooms.` : ''}
  Keep the tone elegant, business-premium, and engaging for potential high-net-worth buyers. Maximum 150 words.`;

  try {
    // Correct usage of generateContent with model name and prompt string.
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: prompt,
    });
    // Correctly extract text using the .text property as per guidelines.
    return response.text;
  } catch (error) {
    console.error("Gemini Error:", error);
    return "Error generating AI description. Please write manually.";
  }
}
